'use client';

import React__default, { useState, useRef, useEffect } from 'react';
import Calendar from '../../Calendar/index.js';
import { PickerContainer, InputRange, InputRangeField, Icon, CalendarWrap } from '../styles.css.js';
import { EDatePicker } from '../type.js';
import { datetimeFormat, formatInputDate } from '../utils/dateTimeFormat.js';
import Input from '../../Input/index.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutSide.js';
import { CalendarIcon } from '../../Images/Calendar/Calendar.js';
import { LongArrowRight } from '../../Images/Arrows/index.js';

function RangePicker(_a) {
    var defaultDates = _a.defaultDates, onChange = _a.onChange, min = _a.min, max = _a.max, _b = _a.type, type = _b === void 0 ? EDatePicker.month : _b, pickerType = _a.pickerType, calendarStyle = _a.calendarStyle, placeholder = _a.placeholder;
    var _c = useState(defaultDates), dates = _c[0], setDates = _c[1];
    var _d = useState(''), startValue = _d[0], setStartValue = _d[1];
    var _e = useState(''), endValue = _e[0], setEndValue = _e[1];
    var _f = useState(false), isShowCalendar = _f[0], setIsShowCalendar = _f[1];
    var calendarRef = useRef(null);
    var datePickerRef = useRef(null);
    var handleClickCalendar = function (dates) {
        setDates(dates);
        var startDate = datetimeFormat(dates[0], type);
        var endDate = datetimeFormat(dates[1], type);
        setStartValue(startDate);
        setEndValue(endDate);
        onChange && onChange(dates);
        if (dates && dates.length > 1) {
            setIsShowCalendar(false);
        }
    };
    var validate = function (value) {
        if (!formatInputDate(value, type)) {
            setStartValue('');
            setEndValue('');
            onChange && onChange(null);
        }
    };
    var handleChangeInputStart = function (value) {
        var _a;
        setStartValue(value);
        var formattedDate = formatInputDate(value, type, 'string');
        if (formattedDate && calendarRef.current) {
            var date = formatInputDate(value, type, 'Date');
            var endDate = (_a = (dates && dates[1])) !== null && _a !== void 0 ? _a : null;
            if (endDate && date && date > endDate) {
                setEndValue('');
                calendarRef.current.onPicker(null);
                return;
            }
            calendarRef.current.onPicker(new Date(date));
        }
        if (!value && calendarRef.current) {
            setEndValue('');
            setDates(null);
            calendarRef.current.onPicker(null);
        }
    };
    var handleChangeInputEnd = function (value) {
        var _a;
        setEndValue(value);
        var formattedDate = formatInputDate(value, type, 'string');
        if (formattedDate && calendarRef.current) {
            var date = formatInputDate(value, type, 'Date');
            var startDate = (_a = (dates && dates[0])) !== null && _a !== void 0 ? _a : null;
            if (startDate && date && date < startDate) {
                setEndValue('');
                calendarRef.current.onPicker(null);
                return;
            }
            calendarRef.current.onPicker(new Date(date));
        }
        if (!value && calendarRef.current) {
            setStartValue('');
            calendarRef.current.onPicker(null);
            setDates(null);
        }
    };
    var onShowCalendar = function () {
        setIsShowCalendar(!isShowCalendar);
    };
    useEffect(function () {
        if (dates && dates.length > 0) {
            var startDate = datetimeFormat(dates[0], type);
            setStartValue(startDate);
        }
        if (dates && dates.length > 1) {
            var endDate = datetimeFormat(dates[1], type);
            setEndValue(endDate);
        }
    }, [dates]);
    var handleClickOutside = function () {
        setIsShowCalendar(false);
    };
    useOnClickOutside(datePickerRef, handleClickOutside);
    return (React__default.createElement(PickerContainer, { ref: datePickerRef, onFocus: function () {
            setIsShowCalendar(true);
        } },
        React__default.createElement(InputRange, null,
            React__default.createElement(InputRangeField, null,
                React__default.createElement(Input, { type: 'text', value: startValue, onBlur: function () { return validate(startValue); }, onFocus: function () { return setIsShowCalendar(true); }, onChange: function (value) { return handleChangeInputStart(value !== null && value !== void 0 ? value : ''); }, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'dd/mm/yyyy', clearValue: false }),
                React__default.createElement("div", { style: { zIndex: 0 } },
                    React__default.createElement(LongArrowRight, null)),
                React__default.createElement(Input, { type: 'text', value: endValue !== null && endValue !== void 0 ? endValue : '', disabled: !startValue, onBlur: function () { return validate(endValue); }, onFocus: function () { return setIsShowCalendar(true); }, onChange: function (value) { return handleChangeInputEnd(value !== null && value !== void 0 ? value : ''); }, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'dd/mm/yyyy', clearValue: true })),
            React__default.createElement(Icon, { isRounded: true, isIcon: true, type: 'transparent', isOutline: false, onClick: onShowCalendar },
                React__default.createElement(CalendarIcon, null))),
        React__default.createElement(CalendarWrap, { show: isShowCalendar ? 1 : 0 },
            React__default.createElement(Calendar, { ref: calendarRef, initDates: dates, pickerType: pickerType, calendarStyle: calendarStyle, min: min, max: max, type: type, handleDateClick: handleClickCalendar }))));
}

export { RangePicker as default };
//# sourceMappingURL=RangePicker.js.map
